import { z } from 'zod';
import { paginationQuerySchema } from '../common/envelope.js';
export const WHATSAPP_MESSAGE_TYPES = ['text', 'image', 'document', 'audio', 'video', 'location', 'template'];
export const whatsAppMessageTypeSchema = z.enum(WHATSAPP_MESSAGE_TYPES);
export const whatsAppMessageStatusSchema = z.enum(['pending', 'sent', 'delivered', 'read', 'failed']);
export const whatsAppMessageResponseSchema = z.object({
    id: z.string().uuid(),
    conversationId: z.string().uuid(),
    providerMessageId: z.string().nullable(),
    direction: z.enum(['inbound', 'outbound']),
    messageType: whatsAppMessageTypeSchema,
    textBody: z.string().nullable(),
    mediaId: z.string().nullable(),
    mediaMimeType: z.string().nullable(),
    templateName: z.string().nullable(),
    status: whatsAppMessageStatusSchema,
    errorMessage: z.string().nullable(),
    sentByMembershipId: z.string().uuid().nullable(),
    sentByName: z.string().nullable(),
    occurredAt: z.string().datetime(),
});
/** Same generic shape as `Task.relatedTo` (`packages/contracts/src/tasks/schemas.ts`)
 * — one of Lead/Contact/Company, or null for a sender not yet matched to
 * any CRM record. */
export const whatsAppLinkedRecordSchema = z.object({
    type: z.enum(['lead', 'contact', 'company']),
    id: z.string().uuid(),
    label: z.string(),
});
export const whatsAppConversationResponseSchema = z.object({
    id: z.string().uuid(),
    waContactId: z.string().uuid(),
    phoneE164: z.string(),
    profileName: z.string().nullable(),
    linkedRecord: whatsAppLinkedRecordSchema.nullable(),
    status: z.enum(['open', 'closed']),
    assignedMembershipId: z.string().uuid().nullable(),
    assignedName: z.string().nullable(),
    lastMessageAt: z.string().datetime().nullable(),
    lastMessagePreview: z.string().nullable(),
    unreadCount: z.number().int(),
    createdAt: z.string().datetime(),
});
export const listWhatsAppConversationsQuerySchema = paginationQuerySchema.extend({
    status: z.enum(['open', 'closed']).optional(),
    assignedToMe: z.coerce.boolean().optional(),
    unassigned: z.coerce.boolean().optional(),
});
/** Text-only for v1 — the spec's other message types (image/document/
 * audio/video/location/template) are received and stored (see
 * `WhatsAppMessageType` above) but not yet composable from this screen;
 * disclosed here rather than silently unsupported. */
export const sendWhatsAppMessageInputSchema = z.object({
    text: z.string().trim().min(1).max(4096),
});
export const assignWhatsAppConversationInputSchema = z.object({
    membershipId: z.string().uuid().nullable(),
});
/** Admin ▸ Integrations ▸ WhatsApp — unlike AI qualification, there's no
 * provider/model/threshold to configure here (the Meta Cloud API
 * credentials are env vars/Doppler, same as Twilio's calling settings);
 * `enabled` is a tenant-level kill switch independent of whether those
 * env vars are even set, e.g. to pause processing without pulling
 * credentials. */
export const whatsAppSettingsSchema = z.object({
    enabled: z.boolean().default(true),
});
//# sourceMappingURL=schemas.js.map